import { getETHPrice } from "../../Api";

export const getEtherPrice = async () => {
  const response = await getETHPrice();
  const price = await response!.price;
  const eth = (1 / price).toFixed(10);
  return eth;
};
